export { default as GamepadIcon } from './GamepadIcon'
export { default as ServicesIcon } from './ServicesIcon'
export { default as ProgramsIcon } from './ProgramsIcon'
export { default as MailIcon } from './MailIcon'
export { default as PhoneIcon } from './PhoneIcon'
export { default as ExitIcon } from './ExitIcon'
export { default as ShieldIcon } from './ShieldIcon'
export { default as RedFireIcon } from './RedFireIcon'
export { default as ShieldSmallIcon } from './ShieldSmallIcon'
export { default as YellowFireIcon } from './YellowFireIcon'
export { default as CloseIcon } from './CloseIcon'
export { default as SbpIcon } from './SbpIcon'
export { default as MtsIcon } from './MtsIcon'
export { default as OldArrowDown } from './OldArrowDown'
export { default as ErrorIcon } from './ErrorIcon'
export { default as NspkIcon } from './NspkIcon'
export { default as SslIcon } from './SslIcon'
export { default as ReceiptIcon } from './ReceiptIcon'
export { default as HomeIcon } from './HomeIcon'
export { default as KeyIcon } from './KeyIcon'

// redesign
export { default as ArrowRight } from './ArrowRight'
export { default as ArrowLeft } from './ArrowLeft'
export { default as ArrowDown } from './ArrowDown'
export { default as ArrowTop } from './ArrowTop'
export { default as PlusIcon } from './PlusIcon'
export { default as SearchIcon } from './SearchIcon'
export { default as FireIcon } from './FireIcon'
export { default as BookMarkIcon } from './BookMarkIcon'
export { default as TelegramIcon } from './TelegramIcon'
export { default as CircleFireIcon } from './CircleFireIcon'
export { default as CopyIcon } from './CopyIcon'
export { default as GiftIcon } from './GiftIcon'
export { default as MultitransferIcon } from './MultitransferIcon'
export { default as CrossIcon } from './CrossIcon'
export { default as CheckIcon } from './CheckIcon'
export { default as SmallFireIcon } from './SmallFireIcon'
export { default as InfoIcon } from './InfoIcon'
export { default as DiscountIcon } from './DiscountIcon'
export { default as SteamIcon } from './SteamIcon'
export { default as CircleCheckIcon } from './CircleCheckIcon'
export { default as TriangleErrorIcon } from './TriangleErrorIcon'
export { default as CircleInfoIcon } from './CircleInfoIcon'
export { default as CircleWarningIcon } from './CircleWarningIcon'
export { default as UserIcon } from './UserIcon'
export { default as SquareInfoIcon } from './SquareInfoIcon'
export { default as SheildPaymentIcon } from './SheildPaymentIcon'
export { default as MasterCardIcon } from './MasterCardIcon'
export { default as MIRIcon } from './MIRIcon'
export { default as VisaIcon } from './VisaIcon'
export { default as CardIcon } from './CardIcon'
export { default as RejectIcon } from './RejectIcon'
export { default as MinusIcon } from './MinusIcon'
export { default as CircleQuestionIcon } from './CircleQuestionIcon'
export { default as SquareQuestionIcon } from './SquareQuestionIcon'
export { default as ShiningGiftIcon } from './ShiningGiftIcon'
export { default as ReviewIcon } from './ReviewIcon'
export { default as SupportIcon } from './SupportIcon'
export { default as ForeignCardIcon } from './ForeignCardIcon'
